import React, { memo } from 'react';
import { Divider } from '../../divider';
import { useListDivider } from './use-list-divider';
import styles from './styles.module.css';
export const ListDivider = /*#__PURE__*/memo(function ListDivider() {
  const {
    size
  } = useListDivider();
  return /*#__PURE__*/React.createElement(Divider, {
    className: styles[size]
  });
});